import React from 'react'

import { withStyles, WithStyles, createStyles } from '@material-ui/core'

import { FormattedNumber } from 'react-intl'
import { IMoney, Currency as Currencies } from 'protos'

interface CurrencyProps {
  value?: IMoney['value']
  currency?: IMoney['currency']
}

const toCurrency = (currency: IMoney['currency']) => {
  switch (currency) {
    case Currencies.CR_EUR_CENT: return 'EUR'
    case Currencies.CR_GBP_CENT: return 'GBP'
    case Currencies.CR_USD_CENT: return 'USD'
    case Currencies.CR_HUF: return 'HUF'
    default: return 'EUR'
  }
}
const toNumber = (value: IMoney['value']) => +(value || 0)
const isVirtual = (currency: IMoney['currency']) => currency === Currencies.CR_VIRTUAL

const styles = createStyles({
  koinCurrency: {
    position: 'relative',
    top: '-0.2em',
  },
})

type InjectedProps = CurrencyProps & WithStyles<typeof styles>

const Currency: React.SFC<InjectedProps> = ({
  value,
  classes,
  currency,
}) => isVirtual(currency)
  ? <><span className={classes.koinCurrency}>k</span><FormattedNumber value={toNumber(value)} /></>
  : <FormattedNumber style={'currency' as 'currency'} currency={toCurrency(currency)} value={toNumber(value)} />

Currency.defaultProps = {
  currency: Currencies.CR_VIRTUAL
}

export default withStyles(styles)(Currency)
